export enum DictionaryType {
  UI = 'ui',
  Help = 'help',
}
